import { ConnectProto } from "@racoon/api";
import { plannedContainerCount } from "~/shared/lib/job-containers";

export const COEFFICIENT_OPTIONS = [0, 0.5, 0.75, 1, 1.25] as const;

const round = (value: number, digits: number) => {
  const factor = 10 ** digits;
  return Math.round(value * factor) / factor;
};

// m³ of one container: the container group's type, else the legacy per-job type.
export const containerVolume = (job: ConnectProto.Job): number | undefined => {
  const volume = job.containerGroup?.containerType?.volume ?? job.containerType?.volume;
  return volume && volume > 0 ? volume : undefined;
};

// Whether the job carries reported container facts (fills, a count or a fact
// volume). The group's number of containers is only the plan, so it doesn't count.
const reportsContainers = (job: ConnectProto.Job) =>
  job.containerCoefficients.length > 0 || !!job.numOfContainer || job.factTotalVolume != null;

// Whether the fills bar is shown: reported facts, or a planned count to report
// against — each planned container then shows as full until the first edit.
export const hasContainers = (job: ConnectProto.Job) =>
  reportsContainers(job) || !!plannedContainerCount(job);

/** «8-кубовый (1)»: the container type, and how many the job plans for. */
export const containerLabel = (job: ConnectProto.Job): string | undefined => {
  const name = (job.containerGroup?.containerType ?? job.containerType)?.name;
  if (!name) return undefined;
  const count = plannedContainerCount(job);
  return count ? `${name} (${count})` : name;
};

export const plannedVolume = (job: ConnectProto.Job): number | undefined => {
  const volume = containerVolume(job);
  const count = plannedContainerCount(job);
  return volume && count ? round(volume * count, 3) : undefined;
};

// Σcoefficient × volume, as the backend derives it; count × volume without coefficients.
export const estimatedVolume = (
  coefficients: number[],
  count: number | undefined,
  volume: number | undefined,
): number | undefined => {
  if (!volume) return undefined;
  if (coefficients.length > 0) {
    return round(coefficients.reduce((sum, c) => sum + c, 0) * volume, 3);
  }
  return count !== undefined ? round(count * volume, 3) : undefined;
};
